<template>
  <div class="purchase-information mt-5 lg:mt-10">
    <the-section :title="$t('ec-line004.purchaseInformation.title')">
      <el-form ref="purchase-form" class="purchase-information__form" label-position="top">
        <el-form-item v-if="businessAccountUseFlag" :label="$t('common.label.accountType')" disabled>
          <div class="flex flex-col">
            <el-radio-group :value="data.business_account_flag" disabled>
              <el-radio class="radio-dot" :label="Constants.BUSINESS_ACCOUNT_FLAG.PERSONAL">
                {{ $t('common.label.personal') }}
              </el-radio>
              <el-radio class="radio-dot" :label="Constants.BUSINESS_ACCOUNT_FLAG.BUSINESS">
                {{ $t('common.label.business') }}
              </el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item v-if="corporateFlag" :label="$t('common.memberInformation.companyName')">
          <disabled-input :value="data.company_name" />
        </el-form-item>
        <el-form-item :label="formLabelName">
          <el-row :gutter="16" type="flex">
            <el-col :span="data.name02 ? 12 : 24">
              <disabled-input :value="data.name01" />
            </el-col>
            <el-col v-if="data.name02" :span="12">
              <disabled-input :value="data.name02" />
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-if="data.kana01" :label="formLabelNameKana">
          <el-row :gutter="16" type="flex">
            <el-col :span="data.kana02 ? 12 : 24">
              <disabled-input :value="data.kana01" />
            </el-col>
            <el-col v-if="data.kana02" :span="12">
              <disabled-input :value="data.kana02" />
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-if="data.year && !data.business_account_flag" :label="$t('common.memberInformation.birthday')">
          <el-row type="flex" :gutter="4" justify="space-between" align="middle">
            <el-col :span="7">
              <disabled-input :value="data.year" />
            </el-col>
            <el-col :span="1">{{ $t('common.dateSeparator') }}</el-col>
            <el-col :span="7">
              <disabled-input :value="data.month" />
            </el-col>
            <el-col :span="1">{{ $t('common.dateSeparator') }}</el-col>
            <el-col :span="7">
              <disabled-input :value="data.day" />
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-if="data.gender && !data.business_account_flag" :label="$t('common.memberInformation.gender')">
          <disabled-input :value="data.gender" />
        </el-form-item>
        <el-form-item :label="$t('common.memberInformation.email')">
          <disabled-input :value="data.email" />
        </el-form-item>
        <el-form-item :label="$t('common.memberInformation.emailConfirm')">
          <disabled-input :value="data.email_confirm" />
        </el-form-item>
        <el-form-item :label="$t('common.memberInformation.postalCode')">
          <el-row :gutter="16">
            <el-col :span="12">
              <disabled-input :value="data.postal_code01" />
            </el-col>
            <el-col :span="12">
              <disabled-input :value="data.postal_code02" />
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('common.memberInformation.prefectures')">
          <disabled-input :value="data.prefecture" />
        </el-form-item>
        <el-form-item :label="$t('common.memberInformation.addr01')">
          <disabled-input :value="data.addr01" />
        </el-form-item>
        <el-form-item :label="$t('common.memberInformation.addr02')">
          <disabled-input :value="data.addr02" />
        </el-form-item>
        <el-form-item :label="$t('common.memberInformation.addr03')">
          <disabled-input :value="data.addr03" />
        </el-form-item>
        <el-form-item :label="$t('common.memberInformation.phoneNumber')">
          <disabled-input :value="data.phone_number" />
        </el-form-item>
      </el-form>
    </the-section>
  </div>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
import DisabledInput from '@/components/DisabledInput.vue'

export default {
  components: { TheSection, DisabledInput },
  props: {
    data: { type: Object, default: () => {} },
  },
  computed: {
    businessAccountUseFlag() {
      return this.$store.getters['auth/shop']?.business_account_use_flag
    },
    corporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
    formLabelName() {
      return this.corporateFlag || !this.data.business_account_flag
        ? this.$t('common.memberInformation.fullName')
        : this.$t('common.memberInformation.companyName')
    },
    formLabelNameKana() {
      return this.corporateFlag || !this.data.business_account_flag
        ? this.$t('common.memberInformation.nameKana')
        : this.$t('common.memberInformation.companyNameKana')
    },
  },
}
</script>
